import { __rest, __assign } from './../../vendor/tslib/tslib.es6.js';
import React__default from 'react';
import classNames from 'classnames';
import { createIsSupportedVariant } from '../utils.js';
import styles from './Button.module.css.js';

var VARIANT_NAMES = ['primary', 'secondary', 'ghost'];
var getIsSupportedVariant = createIsSupportedVariant(VARIANT_NAMES);
var VARIANT_SIZES = ['small', 'medium', 'large'];
var getIsSupportedSizeVariant = createIsSupportedVariant(VARIANT_SIZES);
var Button = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, _c = _a.variant, variant = _c === void 0 ? 'secondary' : _c, _d = _a.size, size = _d === void 0 ? 'responsive' : _d, sizeVariant = _a.sizeVariant, onClick = _a.onClick, _e = _a.disabled, disabled = _e === void 0 ? false : _e, restProps = __rest(_a, ["children", "className", "variant", "size", "sizeVariant", "onClick", "disabled"]);
    var ariaLabel = restProps["aria-label"], htmlButtonAttributes = __rest(restProps, ['aria-label']);
    var safeVariant = getIsSupportedVariant(variant) ? variant : 'primary';
    var variantClassName = styles[safeVariant];
    var safeSizeVariant = sizeVariant && getIsSupportedSizeVariant(sizeVariant) ? sizeVariant : undefined;
    var sizeVariantClassName = safeSizeVariant && styles[safeSizeVariant];
    var classes = classNames(styles.root, variantClassName, sizeVariantClassName, (_b = {},
        _b[styles.defaultSize] = !sizeVariant,
        _b[styles.block] = size === 'block',
        _b[styles.disabled] = disabled,
        _b), className);
    return (React__default.createElement("button", __assign({ type: "button", className: classes, onClick: onClick, disabled: disabled, "aria-disabled": disabled, "aria-label": ariaLabel === null || ariaLabel === void 0 ? void 0 : ariaLabel.toString() }, htmlButtonAttributes), children));
};
Button.displayName = 'Button';
var BUTTON_DISPLAY_NAME = Button.displayName;

export { BUTTON_DISPLAY_NAME, Button };
//# sourceMappingURL=Button.js.map
